import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { configureStore } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { GoogleAuthProvider } from "./contexts/GoogleAuthContext";
import AutoLogout from "./components/AutoLogout"; // Asegúrate de que la ruta sea correcta
import AuditLogger from "./routes/AuditLogger";
import "./i18n"; // Configuración de internacionalización

// Crea el store una sola vez
const store = configureStore({});

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <Provider store={store}>
    <GoogleAuthProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <AuditLogger />
        <AutoLogout>
          <App />
        </AutoLogout>
      </BrowserRouter>
    </GoogleAuthProvider>
  </Provider>
);
